export const INITIALIZE_STATE = 'INITIALIZE_STATE';
export const UPDATE_STATE_DRY_RUN_OPTIONS1 = 'UPDATE_STATE_DRY_RUN_OPTIONS1';
export const UPDATE_STATE_DRY_RUN_OPTIONS2 = 'UPDATE_STATE_DRY_RUN_OPTIONS2';
export const UPDATE_STATE_DRY_RUN_CONTENT = 'UPDATE_STATE_DRY_RUN_CONTENT';
